export const CLEANUP_RECEIPT_STATE = 'cleanup-receipt-state';
const cleanupReceiptState = () => ({ type: CLEANUP_RECEIPT_STATE });
export default cleanupReceiptState;